import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import EditDepositPromotionListing from '@/modules/promotion/components/EditDepositPromotion/components/EditDepositPromotionListing'

function EditDepositPromotionPage() {
	return (
		<PageContainer>
			<EditDepositPromotionListing />
		</PageContainer>
	)
}

const GuardedEditDepositPromotionPage = withUserPermission(
	EditDepositPromotionPage,
	{
		permissionType: PermissionType.Write,
		permissionKey: [PermissionKeys.MANAGE_DEPOSIT_PROMOTION],
	},
)

export default GuardedEditDepositPromotionPage
